<template>
  <a v-bind:class="['system-link', {loading: loading}]" v-bind:href="url" target="_blank"><slot></slot></a>
</template>

<script>
export default {
  name: 'versionedContentLink',
  props: {
    contentType: String,
    href: String
  },
  data () {
    return {}
  },
  computed: {
    url() {
      switch(this.contentType) {
        case 'TERMS_AND_CONDITIONS':
          return this.$store.state.versionedContent.tncUrl;
        case 'PRIVACY_POLICY':
          return this.$store.state.versionedContent.ppUrl;
        default:
          if (this.href) return this.href;
          console.warn(`Unknown content type ${this.contentType}, falling back to tnc`);
          return this.$store.state.versionedContent.tncUrl;
      }
    },
    loading() {
      return this.$store.state.versionedContent.loading;
    }
  },
}
</script>

<style lang="scss" scoped>
  .system-link {
    transition: all .5s ease-in-out;
    text-decoration: underline;
    &.loading {
      text-decoration: underline solid transparent;
      color: inherit;
      cursor: pointer;
    }
  }
</style>
